<div class="navigatie">
	<app-button (clickit)="goBack()" buttonType="text" icon="chevron-left">Terug naar chats</app-button>
	<app-button [enabled]="!!vorige()" (clickit)="gotoChat(vorige()!)" buttonType="secondary" icon="chevron-left">Vorige</app-button>
	<app-button [enabled]="!!volgende()" (clickit)="gotoChat(volgende()!)" buttonType="secondary" icon="chevron-right" icon-right
		>Volgende</app-button
	>
</div>
@if (conversatie(); as conversatie) {
	<div class="header">
		<h2>Gespreksdetails</h2>
	</div>
	<div class="cards">
		<div class="row">
			<div class="column">
				<div class="card turns">
					<div class="chat-header">
						<h3>{{ conversatie.onderwerp }}</h3>
						<div class="status-beheer">
							<span class="label">Status</span>
							<app-single-select-dropdown
								[opties]="statusOptions"
								[selectedOptie]="getSelectedStatus()"
								(onOptieClicked)="setStatus($event)"
							/>
						</div>
					</div>
					<div class="details">
						{{ conversatie.account.naam }}
						@if (conversatie.impersonator; as impersonator) {
							<span class="impersonator">({{ formatImpersonator(impersonator) }})</span>
						}
						| {{ conversatie.instelling.naam }} | {{ conversatie.lastModified | date: "medium" }}
						@if (conversatie.tokens !== undefined && conversatie.tokens !== null) {
							<!-- Het opgeslagen totaal, niet de som van de turns hieronder: dit is het getal
								waarop geaggregeerd en gesorteerd wordt, dus je wil zien wat er écht in staat. -->
							<span class="tokens" [title]="conversatie.tokens + ' tokens'">| {{ conversatie.tokens | compactNumber }} tokens</span>
						}
						@if (behandeling(); as behandeling) {
							@if (behandeling.statusGewijzigd) {
								<span class="status-audit">
									| {{ getAIChatConversatieStatusName(behandeling.status) }}
									@if (behandeling.behandelaar) {
										door {{ behandeling.behandelaar }}
									}
									op {{ behandeling.statusGewijzigd | date: "short" }}
								</span>
							}
						}
					</div>
					<app-chat-turns
						[turns]="conversatie.turns"
						[inspect]="true"
						[opmerkingen]="behandeling()?.opmerkingen ?? []"
						[gebruiker]="gebruikersnaam()"
						(goToDashboard)="goToDashboard($event)"
						(opmerkingToevoegen)="voegOpmerkingToe($event)"
						(opmerkingWijzigen)="wijzigOpmerking($event)"
						(opmerkingVerwijderen)="verwijderOpmerking($event)"
					/>
					<div class="conversatie-opmerkingen">
						<h4>Opmerkingen</h4>
						<app-chat-opmerkingen
							[opmerkingen]="conversatieOpmerkingen()"
							(wijzigen)="wijzigOpmerking($event)"
							(verwijderen)="verwijderOpmerking($event)"
						/>
						<app-button buttonType="text" icon="feedback" (clickit)="voegOpmerkingToe()">Opmerking toevoegen</app-button>
					</div>
				</div>
			</div>
			<div class="column">
				<div class="card other-chats">
					<h3>Andere gesprekken</h3>
					<div class="details">Van {{ conversatie.account.naam }}</div>
					@if (otherConversations$ | async; as otherConversations) {
						<ul class="chats">
							@for (chat of otherConversations; track chat.id) {
								<li (click)="gotoChat(chat)">
									<div class="chat-date">
										{{ chat.lastModified | date: "short" }}
										@if (chat.sentiment !== undefined && SENTIMENT_ICON[chat.sentiment]; as icon) {
											<app-icon [name]="icon.name" [color]="icon.color" class="icon" size="small"></app-icon>
										}
									</div>
									<div class="chat-subject">{{ chat.onderwerp }}</div>
								</li>
							}
						</ul>
					}
				</div>
			</div>
		</div>
	</div>
}

<ng-template #confirmOpmerkingVerwijderen>
	<app-confirm-dialog caption="Notitie verwijderen" action="Verwijderen">
		Deze notitie wordt definitief verwijderd. Weet je het zeker?
	</app-confirm-dialog>
</ng-template>
